module.exports = __webpack_public_path__ + "static/media/lumbering24.08f47b9a.jpg";